import axios, {AxiosResponse} from "axios";
import get from "lodash-es/get";
import config from "app/api/axiosConfig";
import { Album } from 'app/api/types';

export default (token: string) =>
	axios.get(`${process.env.REACT_APP_GALLERY_HOST}/gallery/albums`, config(token))
		.then((response: AxiosResponse) => {
			const chats: Album[] = get(response, "data", {});
			return Promise.resolve(chats)
		})
